import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./ScrollToTop.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'

const ScrollToTop = () => {
  const location = useLocation();

  const [scrollPercent, setScrollPercent] = useState(0);
  const [visible, setVisible] = useState(false);
  const [complete, setComplete] = useState(false);

  // disable browser auto scroll restore (VERY IMPORTANT)
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  // detect scroll (HOME + OTHER PAGES)
  useEffect(() => {
    const handleScroll = () => {
      const homeContainer = document.querySelector(".scroll-container");

      let scrollTop = 0;
      let scrollHeight = 0;

      // HOME PAGE (custom scroll)
      if (homeContainer && location.pathname === "/") {
        scrollTop = homeContainer.scrollTop;
        scrollHeight =
          homeContainer.scrollHeight - homeContainer.clientHeight;
      }
      // OTHER PAGES (window scroll)
      else {
        scrollTop = window.scrollY;
        scrollHeight =
          document.documentElement.scrollHeight - window.innerHeight;
      }

      const percent =
        scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;

      setScrollPercent(percent);
      setVisible(percent > 10);
      setComplete(percent > 99);
    };

    window.addEventListener("scroll", handleScroll);

    // also listen home container
    const homeContainer = document.querySelector(".scroll-container");
    homeContainer?.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      homeContainer?.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);

  // RESET SCROLL ON ROUTE CHANGE (MAIN FIX)
  useEffect(() => {
    setTimeout(() => {
      // window pages reset
      window.scrollTo(0, 0);

      // home reset
      const homeContainer = document.querySelector(".scroll-container");
      if (homeContainer) {
        homeContainer.scrollTop = 0;
      }
    }, 0);
  }, [location.pathname]);

  const radius = 26;
  const circumference = 2 * Math.PI * radius;
  const offset =
    circumference - (scrollPercent / 100) * circumference;

  const scrollToTop = () => {
    const homeContainer = document.querySelector(".scroll-container");

    if (location.pathname === "/" && homeContainer) {
      homeContainer.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div
      className={`scroll-top-btn ${visible ? "show" : ""} ${complete ? "pulse" : ""
        }`}
      onClick={scrollToTop}
    >
      <svg width="60" height="60">
        <defs>
          <linearGradient id="grad">
            <stop offset="0%" stopColor="#890c25" />
            <stop offset="100%" stopColor="#890c25" />
          </linearGradient>
        </defs>

        <circle cx="30" cy="30" r={radius} stroke="#eee" strokeWidth="4" fill="none" />

        <circle
          cx="30"
          cy="30"
          r={radius}
          stroke="url(#grad)"
          strokeWidth="4"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>

      <span className="arrow">
        <FontAwesomeIcon className="scroll-up-icon" icon={faArrowUp} />
      </span>
    </div>
  );
};

export default ScrollToTop;